import type { SrOrderStatus, SrSalesOrderType } from '@plato/data/starrocks/types';
import { Badge } from '@plato/ui-legacy/components/list-views/badge';
import { useTranslation } from 'react-i18next';
import { getOrderStatusColor, getOrderStatusLabel } from '../utils/order-status.ts';

type Props = {
    status: SrOrderStatus;
    type: SrSalesOrderType;
    className?: string;
};

export function OrderStatusBadge({ status, type, className }: Props) {
    const { t } = useTranslation('order-status');
    const color = getOrderStatusColor(type, status);

    return (
        <Badge color={color} className={className}>
            {getOrderStatusLabel(t, status)}
        </Badge>
    );
}
